import { Type } from "@themes/pollinator/ui/Type";
import { TextItem } from "@themes/pollinator/ui/TextItem";
import { CallToAction } from "@themes/pollinator/ui/CallToAction";
import { marketingContentData } from "../../components/Content";

export type Props = {
  onHireUsClick: () => void;
};

export function MarketingAbout({ onHireUsClick }: Props) {
  return (
    <div className="flex flex-col gap-12">
      <Type variant="body1">
        We build collaborative technology for artists, by artists. We believe in
        the magic of human-to-human intelligence and see Pollinator as a way to
        strengthen cultural ecosystems through peer-to-peer connection.
      </Type>
      <div className="flex flex-wrap gap-4 md:gap-8">
        {marketingContentData.team.map(({ title, description, subheader }) => (
          <TextItem
            key={title}
            title={title}
            subheader={subheader}
            className="w-full md:w-[calc(50%-1rem)]"
          >
            {description}
          </TextItem>
        ))}
      </div>
      <CallToAction
        title="Love Pollinator? Work with us."
        description="We are committed to developing cutting-edge technology for the arts and social impact sectors. Our engineers and directors have worked together for fifteen years as a 'strike team' for corporate clients. Get in touch to learn more about our rates and services."
        primaryButtonText="Hire us"
        onPrimaryClick={onHireUsClick}
        theme="dark"
      />
    </div>
  );
}

export default MarketingAbout;

